import { Box, IconButton } from '@mui/material';
import Draggable from 'react-draggable';

import { FHTooltip } from '../../../../../components/base';
import { FORTA_WHITE } from '../../../../../utils/colors';
import NoteReviewIcon from '../../../../../components/svgs/NoteReviewIcon';

interface ReviewAnchorProps {
  onOpen: () => void;
  disabled: boolean;
}

function ReviewAnchor(props: ReviewAnchorProps) {
  const { onOpen, disabled } = props;

  return (
    <Draggable bounds={'.App'}>
      <Box
        sx={{ position: 'absolute', right: 10, bottom: 80, zIndex: 1000 }}
        data-testid="sessionGradeButton"
      >
        <FHTooltip
          title={
            'Click here to open the grading block. All information inputed will be saved for later.'
          }
          arrow
          tooltipbackground={FORTA_WHITE}
          tooltipBoxShadow={`0px 4px 4px rgba(0, 0, 0, 0.25)`}
          tooltipBorderRadius="10px"
          placement="top-end"
          sx={{ '& .MuiTooltip-tooltip': { maxWidth: 329 } }}
        >
          <IconButton
            disableRipple
            disabled={disabled}
            onClick={onOpen}
            sx={{ width: 48, height: 48, p: 0 }}
          >
            <NoteReviewIcon />
          </IconButton>
        </FHTooltip>
      </Box>
    </Draggable>
  );
}

export default ReviewAnchor;
